<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <mat-tab-group [selectedIndex]="activeTab" (selectedIndexChange)="onTabChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>Form Entry</ng-template>
        <div class="col-md-12 tab-content-padding form-horizontal">
          <!-- Part I -->
          <div class="row">
            <table class="table table-bordered form-inline custom-table">
              <tbody>
                <tr class="text-right">
                  @for (row of FormEntryData.section1.singlerows; track $index) {
<td [ngClass]="{'color-red': (row != null && +row < 0) }">
                    <span style="font-weight:bold; font-size:18px"><strong>{{ row | numberWithCommas }}</strong></span>
                  </td>
}
                </tr>
              </tbody>
            </table>
            <div class="col-md-12">
              <h4 style="font-weight: bold;">{{ FormEntryData.section1.partITitle }}</h4>
            </div>
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  @for (header of line2Headers; track $index) {
<th [attr.width]="header.property?.width">{{ header.name }}</th>
}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2 <i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer; margin-top: 4px;"
                      title="Add Details" (click)="addSection(2)"></i></td>
                  <td colspan="9">Add Gain or (Loss) Details</td>
                </tr>
                @for (row of FormEntryData.section1.emptyRows; track $index; let i = $index) {
<tr class="text-center">
                  <td>
                    <i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;"
                       title="Remove Details" (click)="sectionRemove(2, i)"></i>
                  </td>
                  <td colspan="9" style="padding: 0px; border: 0px">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tbody>
                        <tr>
                          <td width="15%">
                            <input class="form-control" type="text"
                              [ngModel]="formData_2.addrows[i]?.[0]?.Attribute_Value"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][0].Attribute_Value = $event); errorChange(2, i, 0)">
                            @if (formData_2_errorMessages.addrows[i]?.[0]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][0].column_error }}</span>
}
                          </td>
                          <td width="11%">
                            <input class="form-control" type="date"
                              [ngModel]="formData_2.addrows[i]?.[1]?.Attribute_Value | date:'yyyy-MM-dd'"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][1].Attribute_Value = $event); errorChange(2, i, 1)">
                            @if (formData_2_errorMessages.addrows[i]?.[1]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][1].column_error }}</span>
}
                          </td>
                          <td width="11%">
                            <input class="form-control" type="date"
                              [ngModel]="formData_2.addrows[i]?.[2]?.Attribute_Value | date:'yyyy-MM-dd'"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][2].Attribute_Value = $event); errorChange(2, i, 2)">
                            @if (formData_2_errorMessages.addrows[i]?.[2]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][2].column_error }}</span>
}
                          </td>
                          <td width="11%">
                            <input class="form-control input-sm numText" style="text-align: right;" type="number"
                              [ngModel]="formData_2.addrows[i]?.[3]?.Attribute_Value"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][3].Attribute_Value = $event); setGainLoss(2, false, i); errorChange(2, i, 3)">
                            @if (formData_2_errorMessages.addrows[i]?.[3]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][3].column_error }}</span>
}
                          </td>
                          <td width="11%">
                            <input class="form-control input-sm numText" style="text-align: right;" type="number"
                              [ngModel]="formData_2.addrows[i]?.[4]?.Attribute_Value"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][4].Attribute_Value = $event); setGainLoss(2, false, i); errorChange(2, i, 4)">
                            @if (formData_2_errorMessages.addrows[i]?.[4]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][4].column_error }}</span>
}
                          </td>
                          <td width="11%">
                            <input class="form-control input-sm numText" style="text-align: right;" type="number"
                              [ngModel]="formData_2.addrows[i]?.[5]?.Attribute_Value"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][5].Attribute_Value = $event); setGainLoss(2, false, i); errorChange(2, i, 5)">
                            @if (formData_2_errorMessages.addrows[i]?.[5]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][5].column_error }}</span>
}
                          </td>
                          <td width="8%">
                            <input type="checkbox" [checked]="formData_2.addrows[i]?.[6]?.Attribute_Value === 'Y'"
                              (change)="formData_2.addrows[i] && (formData_2.addrows[i][6].Attribute_Value = $any($event.target).checked ? 'Y' : 'N'); errorChange(2, i, 6)">
                            @if (formData_2_errorMessages.addrows[i]?.[6]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][6].column_error }}</span>
}
                          </td>
                          <td width="8%">
                            <input type="checkbox" [checked]="formData_2.addrows[i]?.[7]?.Attribute_Value === 'Y'"
                              (change)="formData_2.addrows[i] && (formData_2.addrows[i][7].Attribute_Value = $any($event.target).checked ? 'Y' : 'N'); errorChange(2, i, 7)">
                            @if (formData_2_errorMessages.addrows[i]?.[7]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][7].column_error }}</span>
}
                          </td>
                          <td width="10%" align="right" [ngClass]="{'color-red': formData_2.addrows[i]?.[8]?.Attribute_Value < 0 }">
                            {{ formData_2.addrows[i]?.[8]?.Attribute_Value | numberWithCommas }}
                            @if (formData_2_errorMessages.addrows[i]?.[8]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][8].column_error }}</span>
}
                          </td>
                        </tr>
                        <tr>
                          <td style="border-bottom-width: 0px; text-align: left !important"><h4 style="font-weight: bold;">{{ Form4797Line2HeaderComment.name }}:</h4></td>
                          <td colspan="8" style="width: 180px; border-bottom-width: 0px">
                            <textarea style="width: 100%" class="form-control input-sm" placeholder="<--- Enter Comments here --->"
                              [ngModel]="formData_2.addrows[i]?.[9]?.Attribute_Value"
                              (ngModelChange)="formData_2.addrows[i] && (formData_2.addrows[i][9].Attribute_Value = $event); errorChange(2, i, 9)"></textarea>
                            @if (formData_2_errorMessages.addrows[i]?.[9]?.column_error) {
<span class="form-error-container">{{ formData_2_errorMessages.addrows[i][9].column_error }}</span>
}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
}
                @for (t of form4797Line2Records; track $index; let i = $index) {
<tr>
                  <td>
                    <i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer; margin-top: 4px;" title="Edit Details" (click)="editExistingRecord(2, i)"></i>
                    <i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Remove Details" (click)="removeExistingRecord(2, i, t.rowDimensions?.object_id)"></i>
                  </td>
                  <td colspan="9" style="padding: 0px; border: 0px">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tbody>
                        <tr>
                          <td width="15%">
                            @if (displayViewValue_2[i]) {
<div>{{ t.dataCellList[1]?.value }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input class="form-control" type="text" [ngModel]="t.dataCellList[1]?.value" (ngModelChange)="t.dataCellList[1].value = $event; propChange(2, 0, i)">
                              @if (t.dataCellList[1]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[1].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="11%">
                            @if (displayViewValue_2[i]) {
<div>{{ t.dataCellList[2]?.value | date:'MM/dd/yyyy' }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input class="form-control" type="date" [ngModel]="t.dataCellList[2]?.value | date:'yyyy-MM-dd'" (ngModelChange)="t.dataCellList[2].value = $event; propChange(2, 1, i)">
                              @if (t.dataCellList[2]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[2].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="11%">
                            @if (displayViewValue_2[i]) {
<div>{{ t.dataCellList[3]?.value | date:'MM/dd/yyyy' }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input class="form-control" type="date" [ngModel]="t.dataCellList[3]?.value | date:'yyyy-MM-dd'" (ngModelChange)="t.dataCellList[3].value = $event; propChange(2, 2, i)">
                              @if (t.dataCellList[3]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[3].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="11%" align="right">
                            @if (displayViewValue_2[i]) {
<div [ngClass]="{'color-red': t.dataCellList[4]?.value < 0 }">{{ t.dataCellList[4]?.value | numberWithCommas }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input class="form-control input-sm numText" style="text-align: right;" type="number" [ngModel]="t.dataCellList[4]?.value" (ngModelChange)="t.dataCellList[4].value = $event; setGainLoss(2, true, i); propChange(2, 3, i)">
                              @if (t.dataCellList[4]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[4].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="11%" align="right">
                            @if (displayViewValue_2[i]) {
<div [ngClass]="{'color-red': t.dataCellList[5]?.value < 0 }">{{ t.dataCellList[5]?.value | numberWithCommas }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input class="form-control input-sm numText" style="text-align: right;" type="number" [ngModel]="t.dataCellList[5]?.value" (ngModelChange)="t.dataCellList[5].value = $event; setGainLoss(2, true, i); propChange(2, 4, i)">
                              @if (t.dataCellList[5]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[5].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="11%" align="right">
                            @if (displayViewValue_2[i]) {
<div [ngClass]="{'color-red': t.dataCellList[6]?.value < 0 }">{{ t.dataCellList[6]?.value | numberWithCommas }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input class="form-control input-sm numText" style="text-align: right;" type="number" [ngModel]="t.dataCellList[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; setGainLoss(2, true, i); propChange(2, 5, i)">
                              @if (t.dataCellList[6]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[6].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="8%">
                            @if (displayViewValue_2[i]) {
<div>{{ t.dataCellList[7]?.value }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input type="checkbox" [checked]="t.dataCellList[7]?.value === 'Y'" (change)="t.dataCellList[7].value = $any($event.target).checked ? 'Y' : 'N'; propChange(2, 6, i)">
                              @if (t.dataCellList[7]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[7].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="8%">
                            @if (displayViewValue_2[i]) {
<div>{{ t.dataCellList[8]?.value }}</div>
}
                            @if (displayEditValue_2[i]) {
<div>
                              <input type="checkbox" [checked]="t.dataCellList[8]?.value === 'Y'" (change)="t.dataCellList[8].value = $any($event.target).checked ? 'Y' : 'N'; propChange(2, 7, i)">
                              @if (t.dataCellList[8]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[8].error_message }}</span>
}
                            </div>
}
                          </td>
                          <td width="10%" align="right" [ngClass]="{'color-red': t.dataCellList[9]?.value < 0 }">{{ t.dataCellList[9]?.value | numberWithCommas }}</td>
                        </tr>
                        @if (displayViewValueComment_2[i] && t.dataCellList[10]?.value != null) {
<tr>
                          <td style="border-bottom-width: 0px"><h4 style="font-weight: bold;">{{ Form4797Line2HeaderComment.name }}:</h4></td>
                          <td colspan="8" style="width: 180px; border-bottom-width: 0px">@if (displayViewValue_2[i]) {
<div>{{ t.dataCellList[10]?.value }}</div>
}</td>
                        </tr>
}
                        @if (displayEditValueComment_2[i]) {
<tr>
                          <td style="border-bottom-width: 0px"><h4 style="font-weight: bold;">{{ Form4797Line2HeaderComment.name }}:</h4></td>
                          <td colspan="8" style="width: 180px; border-bottom-width: 0px">
                            <textarea style="width: 100%" class="form-control input-sm" placeholder="<--- Enter Comments here --->"
                              [ngModel]="t.dataCellList[10]?.value" (ngModelChange)="t.dataCellList[10].value = $event; propChange(2, 9, i)"></textarea>
                            @if (t.dataCellList[10]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[10].error_message }}</span>
}
                          </td>
                        </tr>
}
                      </tbody>
                    </table>
                  </td>
                </tr>
}
                <tr>
                  <td>{{ line4Details[0]?.name }}</td>
                  <td colspan="8">{{ line4Details[1]?.name }}</td>
                  <td align="right">
                    <input class="form-control input-sm numText" style="text-align: right;" type="number"
                      [ngModel]="line4Amt" (ngModelChange)="line4Amt = $event; adjustGainLoss(4); lineItemChange(4)">
                  </td>
                </tr>
                <tr>
                  <td>{{ line5Details[0]?.name }}</td>
                  <td colspan="8">{{ line5Details[1]?.name }}</td>
                  <td align="right">
                    <input class="form-control input-sm numText" style="text-align: right;" type="number"
                      [ngModel]="line5Amt" (ngModelChange)="line5Amt = $event; adjustGainLoss(5); lineItemChange(5)">
                  </td>
                </tr>
              </tbody>
              <tfoot>
                @for (foot of FormEntryData.section1.totals; track $index) {
<tr>
                  <th></th>
                  <th colspan="8">{{ foot.description }}</th>
                  <th colspan="1" style="text-align: right;">{{ totalLine2Amt | numberWithCommas }}</th>
                </tr>
}
              </tfoot>
            </table>
          </div>

          <!-- Part II (condensed: add row + existing records + line 14/15/16 + total) -->
          <div class="row">
            <div class="col-md-12"><h4 style="font-weight: bold;">{{ FormEntryData.section2.partIITitle }}</h4></div>
            <table class="table table-bordered custom-table">
              <thead><tr>@for (header of line10Headers; track $index) {
<th [attr.width]="header.property?.width">{{ header.name }}</th>
}</tr></thead>
              <tbody>
                <tr>
                  <td>10 <i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer;" title="Add Details" (click)="addSection(10)"></i></td>
                  <td colspan="9">Add Gain or (Loss) Details</td>
                </tr>
                @for (row of FormEntryData.section2.emptyRows; track $index; let i = $index) {
<tr class="text-center">
                  <td><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer;" title="Remove" (click)="sectionRemove(10, i)"></i></td>
                  <td colspan="9" style="padding: 0;">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tr>
                        <td width="15%"><input class="form-control" type="text" [ngModel]="formData_10.addrows[i]?.[0]?.Attribute_Value" (ngModelChange)="formData_10.addrows[i][0].Attribute_Value = $event; errorChange(10, i, 0)"></td>
                        <td width="11%"><input class="form-control" type="date" [ngModel]="formData_10.addrows[i]?.[1]?.Attribute_Value | date:'yyyy-MM-dd'" (ngModelChange)="formData_10.addrows[i][1].Attribute_Value = $event; errorChange(10, i, 1)"></td>
                        <td width="11%"><input class="form-control" type="date" [ngModel]="formData_10.addrows[i]?.[2]?.Attribute_Value | date:'yyyy-MM-dd'" (ngModelChange)="formData_10.addrows[i][2].Attribute_Value = $event; errorChange(10, i, 2)"></td>
                        <td width="11%"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="formData_10.addrows[i]?.[3]?.Attribute_Value" (ngModelChange)="formData_10.addrows[i][3].Attribute_Value = $event; setGainLoss(10, false, i)"></td>
                        <td width="11%"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="formData_10.addrows[i]?.[4]?.Attribute_Value" (ngModelChange)="formData_10.addrows[i][4].Attribute_Value = $event; setGainLoss(10, false, i)"></td>
                        <td width="11%"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="formData_10.addrows[i]?.[5]?.Attribute_Value" (ngModelChange)="formData_10.addrows[i][5].Attribute_Value = $event; setGainLoss(10, false, i)"></td>
                        <td width="8%"><input type="checkbox" [checked]="formData_10.addrows[i]?.[6]?.Attribute_Value === 'Y'" (change)="formData_10.addrows[i][6].Attribute_Value = $any($event.target).checked ? 'Y' : 'N'"></td>
                        <td width="8%"><input type="checkbox" [checked]="formData_10.addrows[i]?.[7]?.Attribute_Value === 'Y'" (change)="formData_10.addrows[i][7].Attribute_Value = $any($event.target).checked ? 'Y' : 'N'"></td>
                        <td width="10%" align="right" [ngClass]="{'color-red': formData_10.addrows[i]?.[8]?.Attribute_Value < 0 }">{{ formData_10.addrows[i]?.[8]?.Attribute_Value | numberWithCommas }}</td>
                      </tr>
                      <tr><td><h4 style="font-weight: bold;">{{ Form4797Line10HeaderComment.name }}:</h4></td><td colspan="8"><textarea class="form-control input-sm" style="width: 100%" placeholder="Comments" [ngModel]="formData_10.addrows[i]?.[9]?.Attribute_Value" (ngModelChange)="formData_10.addrows[i][9].Attribute_Value = $event"></textarea></td></tr>
                    </table>
                  </td>
                </tr>
}
                @for (t of form4797Line10Records; track $index; let i = $index) {
<tr>
                  <td><i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer;" title="Edit" (click)="editExistingRecord(10, i)"></i><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer;" title="Remove" (click)="removeExistingRecord(10, i, t.rowDimensions?.object_id)"></i></td>
                  <td colspan="9" style="padding: 0;">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tr>
                        <td width="15%">@if (displayViewValue_10[i]) {
<div>{{ t.dataCellList[1]?.value }}</div>
}@if (displayEditValue_10[i]) {
<div><input class="form-control" type="text" [ngModel]="t.dataCellList[1]?.value" (ngModelChange)="t.dataCellList[1].value = $event; propChange(10, 0, i)"></div>
}</td>
                        <td width="11%">@if (displayViewValue_10[i]) {
<div>{{ t.dataCellList[2]?.value | date:'MM/dd/yyyy' }}</div>
}@if (displayEditValue_10[i]) {
<div><input class="form-control" type="date" [ngModel]="t.dataCellList[2]?.value | date:'yyyy-MM-dd'" (ngModelChange)="t.dataCellList[2].value = $event; propChange(10, 1, i)"></div>
}</td>
                        <td width="11%">@if (displayViewValue_10[i]) {
<div>{{ t.dataCellList[3]?.value | date:'MM/dd/yyyy' }}</div>
}@if (displayEditValue_10[i]) {
<div><input class="form-control" type="date" [ngModel]="t.dataCellList[3]?.value | date:'yyyy-MM-dd'" (ngModelChange)="t.dataCellList[3].value = $event; propChange(10, 2, i)"></div>
}</td>
                        <td width="11%" align="right">@if (displayViewValue_10[i]) {
<div [ngClass]="{'color-red': t.dataCellList[4]?.value < 0 }">{{ t.dataCellList[4]?.value | numberWithCommas }}</div>
}@if (displayEditValue_10[i]) {
<div><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="t.dataCellList[4]?.value" (ngModelChange)="t.dataCellList[4].value = $event; setGainLoss(10, true, i); propChange(10, 3, i)"></div>
}</td>
                        <td width="11%" align="right">@if (displayViewValue_10[i]) {
<div [ngClass]="{'color-red': t.dataCellList[5]?.value < 0 }">{{ t.dataCellList[5]?.value | numberWithCommas }}</div>
}@if (displayEditValue_10[i]) {
<div><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="t.dataCellList[5]?.value" (ngModelChange)="t.dataCellList[5].value = $event; setGainLoss(10, true, i); propChange(10, 4, i)"></div>
}</td>
                        <td width="11%" align="right">@if (displayViewValue_10[i]) {
<div [ngClass]="{'color-red': t.dataCellList[6]?.value < 0 }">{{ t.dataCellList[6]?.value | numberWithCommas }}</div>
}@if (displayEditValue_10[i]) {
<div><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="t.dataCellList[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; setGainLoss(10, true, i); propChange(10, 5, i)"></div>
}</td>
                        <td width="8%">@if (displayViewValue_10[i]) {
<div>{{ t.dataCellList[7]?.value }}</div>
}@if (displayEditValue_10[i]) {
<div><input type="checkbox" [checked]="t.dataCellList[7]?.value === 'Y'" (change)="t.dataCellList[7].value = $any($event.target).checked ? 'Y' : 'N'; propChange(10, 6, i)"></div>
}</td>
                        <td width="8%">@if (displayViewValue_10[i]) {
<div>{{ t.dataCellList[8]?.value }}</div>
}@if (displayEditValue_10[i]) {
<div><input type="checkbox" [checked]="t.dataCellList[8]?.value === 'Y'" (change)="t.dataCellList[8].value = $any($event.target).checked ? 'Y' : 'N'; propChange(10, 7, i)"></div>
}</td>
                        <td width="10%" align="right" [ngClass]="{'color-red': t.dataCellList[9]?.value < 0 }">{{ t.dataCellList[9]?.value | numberWithCommas }}</td>
                      </tr>
                      @if (displayEditValueComment_10[i]) {
<tr><td><h4 style="font-weight: bold;">{{ Form4797Line10HeaderComment.name }}:</h4></td><td colspan="8"><textarea class="form-control input-sm" style="width: 100%" [ngModel]="t.dataCellList[10]?.value" (ngModelChange)="t.dataCellList[10].value = $event; propChange(10, 9, i)"></textarea></td></tr>
}
                    </table>
                  </td>
                </tr>
}
                <tr><td>{{ line14Details[0]?.name }}</td><td colspan="8">{{ line14Details[1]?.name }}</td><td align="right"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="line14Amt" (ngModelChange)="line14Amt = $event; adjustGainLoss(14); lineItemChange(14)"></td></tr>
                <tr><td>{{ line15Details[0]?.name }}</td><td colspan="8">{{ line15Details[1]?.name }}</td><td align="right"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="line15Amt" (ngModelChange)="line15Amt = $event; adjustGainLoss(15); lineItemChange(15)"></td></tr>
                <tr><td>{{ line16Details[0]?.name }}</td><td colspan="8">{{ line16Details[1]?.name }}</td><td align="right"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="line16Amt" (ngModelChange)="line16Amt = $event; adjustGainLoss(16); lineItemChange(16)"></td></tr>
              </tbody>
              <tfoot>@for (foot of FormEntryData.section2.totals; track $index) {
<tr><th></th><th colspan="8">{{ foot.description }}</th><th colspan="1" style="text-align: right;">{{ totalLine10Amt | numberWithCommas }}</th></tr>
}</tfoot>
            </table>
          </div>

          <!-- Part III (add row + existing records + total) -->
          <div class="row">
            <div class="col-md-12"><h4 style="font-weight: bold;">{{ FormEntryData.section3.partIIITitle }}</h4></div>
            <table class="table table-bordered custom-table">
              <thead><tr>@for (header of line19Headers; track $index) {
<th [attr.width]="header.property?.width">{{ header.name }}</th>
}</tr></thead>
              <tbody>
                <tr>
                  <td>19 <i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer;" title="Add Details" (click)="addSection(19)"></i></td>
                  <td colspan="9">Add Gain or (Loss) Details</td>
                </tr>
                @for (row of FormEntryData.section3.emptyRows; track $index; let i = $index) {
<tr class="text-center">
                  <td><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer;" title="Remove" (click)="sectionRemove(19, i)"></i></td>
                  <td colspan="9" style="padding: 0;">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tr>
                        <td width="15%"><input class="form-control" type="text" [ngModel]="formData_19.addrows[i]?.[0]?.Attribute_Value" (ngModelChange)="formData_19.addrows[i][0].Attribute_Value = $event"></td>
                        <td width="11%"><input class="form-control" type="date" [ngModel]="formData_19.addrows[i]?.[1]?.Attribute_Value | date:'yyyy-MM-dd'" (ngModelChange)="formData_19.addrows[i][1].Attribute_Value = $event"></td>
                        <td width="11%"><input class="form-control" type="date" [ngModel]="formData_19.addrows[i]?.[2]?.Attribute_Value | date:'yyyy-MM-dd'" (ngModelChange)="formData_19.addrows[i][2].Attribute_Value = $event"></td>
                        <td width="11%"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="formData_19.addrows[i]?.[3]?.Attribute_Value" (ngModelChange)="formData_19.addrows[i][3].Attribute_Value = $event; setGainLoss(19, false, i)"></td>
                        <td width="11%"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="formData_19.addrows[i]?.[4]?.Attribute_Value" (ngModelChange)="formData_19.addrows[i][4].Attribute_Value = $event; setGainLoss(19, false, i)"></td>
                        <td width="11%"><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="formData_19.addrows[i]?.[5]?.Attribute_Value" (ngModelChange)="formData_19.addrows[i][5].Attribute_Value = $event; setGainLoss(19, false, i)"></td>
                        <td width="8%"><input type="checkbox" [checked]="formData_19.addrows[i]?.[6]?.Attribute_Value === 'Y'" (change)="formData_19.addrows[i][6].Attribute_Value = $any($event.target).checked ? 'Y' : 'N'"></td>
                        <td width="8%"><input type="checkbox" [checked]="formData_19.addrows[i]?.[7]?.Attribute_Value === 'Y'" (change)="formData_19.addrows[i][7].Attribute_Value = $any($event.target).checked ? 'Y' : 'N'"></td>
                        <td width="10%" align="right" [ngClass]="{'color-red': formData_19.addrows[i]?.[8]?.Attribute_Value < 0 }">{{ formData_19.addrows[i]?.[8]?.Attribute_Value | numberWithCommas }}</td>
                      </tr>
                      <tr><td><h4 style="font-weight: bold;">{{ Form4797Line19HeaderComment.name }}:</h4></td><td colspan="8"><textarea class="form-control input-sm" style="width: 100%" [ngModel]="formData_19.addrows[i]?.[9]?.Attribute_Value" (ngModelChange)="formData_19.addrows[i][9].Attribute_Value = $event"></textarea></td></tr>
                    </table>
                  </td>
                </tr>
}
                @for (t of form4797Line19Records; track $index; let i = $index) {
<tr>
                  <td><i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer;" title="Edit" (click)="editExistingRecord(19, i)"></i><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer;" title="Remove" (click)="removeExistingRecord(19, i, t.rowDimensions?.object_id)"></i></td>
                  <td colspan="9" style="padding: 0;">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tr>
                        <td width="15%">@if (displayViewValue_19[i]) {
<div>{{ t.dataCellList[1]?.value }}</div>
}@if (displayEditValue_19[i]) {
<div><input class="form-control" type="text" [ngModel]="t.dataCellList[1]?.value" (ngModelChange)="t.dataCellList[1].value = $event; propChange(19, 0, i)"></div>
}</td>
                        <td width="11%">@if (displayViewValue_19[i]) {
<div>{{ t.dataCellList[2]?.value | date:'MM/dd/yyyy' }}</div>
}@if (displayEditValue_19[i]) {
<div><input class="form-control" type="date" [ngModel]="t.dataCellList[2]?.value | date:'yyyy-MM-dd'" (ngModelChange)="t.dataCellList[2].value = $event; propChange(19, 1, i)"></div>
}</td>
                        <td width="11%">@if (displayViewValue_19[i]) {
<div>{{ t.dataCellList[3]?.value | date:'MM/dd/yyyy' }}</div>
}@if (displayEditValue_19[i]) {
<div><input class="form-control" type="date" [ngModel]="t.dataCellList[3]?.value | date:'yyyy-MM-dd'" (ngModelChange)="t.dataCellList[3].value = $event; propChange(19, 2, i)"></div>
}</td>
                        <td width="11%" align="right">@if (displayViewValue_19[i]) {
<div [ngClass]="{'color-red': t.dataCellList[4]?.value < 0 }">{{ t.dataCellList[4]?.value | numberWithCommas }}</div>
}@if (displayEditValue_19[i]) {
<div><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="t.dataCellList[4]?.value" (ngModelChange)="t.dataCellList[4].value = $event; setGainLoss(19, true, i); propChange(19, 3, i)"></div>
}</td>
                        <td width="11%" align="right">@if (displayViewValue_19[i]) {
<div [ngClass]="{'color-red': t.dataCellList[5]?.value < 0 }">{{ t.dataCellList[5]?.value | numberWithCommas }}</div>
}@if (displayEditValue_19[i]) {
<div><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="t.dataCellList[5]?.value" (ngModelChange)="t.dataCellList[5].value = $event; setGainLoss(19, true, i); propChange(19, 4, i)"></div>
}</td>
                        <td width="11%" align="right">@if (displayViewValue_19[i]) {
<div [ngClass]="{'color-red': t.dataCellList[6]?.value < 0 }">{{ t.dataCellList[6]?.value | numberWithCommas }}</div>
}@if (displayEditValue_19[i]) {
<div><input class="form-control input-sm" style="text-align: right;" type="number" [ngModel]="t.dataCellList[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; setGainLoss(19, true, i); propChange(19, 5, i)"></div>
}</td>
                        <td width="8%">@if (displayViewValue_19[i]) {
<div>{{ t.dataCellList[7]?.value }}</div>
}@if (displayEditValue_19[i]) {
<div><input type="checkbox" [checked]="t.dataCellList[7]?.value === 'Y'" (change)="t.dataCellList[7].value = $any($event.target).checked ? 'Y' : 'N'; propChange(19, 6, i)"></div>
}</td>
                        <td width="8%">@if (displayViewValue_19[i]) {
<div>{{ t.dataCellList[8]?.value }}</div>
}@if (displayEditValue_19[i]) {
<div><input type="checkbox" [checked]="t.dataCellList[8]?.value === 'Y'" (change)="t.dataCellList[8].value = $any($event.target).checked ? 'Y' : 'N'; propChange(19, 7, i)"></div>
}</td>
                        <td width="10%" align="right" [ngClass]="{'color-red': t.dataCellList[9]?.value < 0 }">{{ t.dataCellList[9]?.value | numberWithCommas }}</td>
                      </tr>
                      @if (displayEditValueComment_19[i]) {
<tr><td><h4 style="font-weight: bold;">{{ Form4797Line19HeaderComment.name }}:</h4></td><td colspan="8"><textarea class="form-control input-sm" style="width: 100%" [ngModel]="t.dataCellList[10]?.value" (ngModelChange)="t.dataCellList[10].value = $event; propChange(19, 9, i)"></textarea></td></tr>
}
                    </table>
                  </td>
                </tr>
}
              </tbody>
              <tfoot>@for (foot of FormEntryData.section3.totals; track $index) {
<tr><th></th><th colspan="8">{{ foot.description }}</th><th colspan="1" style="text-align: right;">{{ totalLine19Amt | numberWithCommas }}</th></tr>
}</tfoot>
            </table>
          </div>

          <!-- Summary totals (from original entry) -->
          <table class="table table-bordered form-inline custom-table">
            <tbody>
              <tr class="text-right"><td><span style="font-weight:bold; font-size:18px"><strong>{{ totalPerTaxReturn[0]?.name }}</strong></span></td><td align="right" [ngClass]="{'color-red': totalPerTaxReturn[1]?.value < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ totalPerTaxReturn[1]?.value | numberWithCommas }}</strong></span></td></tr>
              <tr class="text-right"><td><span style="font-weight:bold; font-size:18px">{{ totalPerDetailsLines[0]?.name }}</span></td><td align="right" [ngClass]="{'color-red': totalPerDetailsLines[1]?.value < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ totalPerDetailsLines[1]?.value | numberWithCommas }}</strong></span></td></tr>
              <tr class="text-right"><td><span style="font-weight:bold; font-size:18px"><strong>{{ totalPerUnallocated[0]?.name }}</strong></span></td><td align="right" [ngClass]="{'color-red': totalPerUnallocated[1]?.value < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ totalPerUnallocated[1]?.value | numberWithCommas }}</strong></span></td></tr>
              <tr class="text-right"><td><span style="font-weight:bold; font-size:18px">{{ totalPerForm4797[0]?.name }}</span></td><td align="right" [ngClass]="{'color-red': totalPerForm4797[1]?.value < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ totalPerForm4797[1]?.value | numberWithCommas }}</strong></span></td></tr>
              <tr class="text-right"><td><span style="font-weight:bold; font-size:18px">{{ totalUnallocatedAmt[0]?.name }}</span></td><td align="right" [ngClass]="{'color-red': totalUnallocatedAmt[1]?.value < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ totalUnallocatedAmt[1]?.value | numberWithCommas }}</strong></span></td></tr>
            </tbody>
          </table>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>Form View</ng-template>
        <div class="col-md-12 tab-content-padding">
          <div class="form-horizontal">
            @if (viewData.partI) {
<div class="row">
              <div class="col-md-12">
                <h4 style="font-weight: bold;">{{ viewData.partI.title }}</h4>
              </div>
              <table class="table table-bordered custom-table">
                <thead><tr>@for (col of viewData.partI.cols; track $index) {
<th>{{ col }}</th>
}</tr></thead>
                <tbody>
                  @for (row of viewData.partI.rows; track $index) {
<tr><td></td>@for (c of viewData.partI.cols; track $index; let j = $index) {
<td><input class="form-control" type="text" /></td>
}</tr>
}
                  @for (row of viewData.partI.rows2; track $index) {
<tr><td>{{ row.num }}</td><td colspan="8">{{ row.description }}</td><td></td></tr>
}
                </tbody>
                <tfoot>@for (foot of viewData.partI.totals; track $index) {
<tr><th></th><th colspan="7">{{ foot.description }}</th><th colspan="2"></th></tr>
}</tfoot>
              </table>
            </div>
}
            @if (viewData.partII) {
<div class="row">
              <div class="col-md-12"><h4 style="font-weight: bold;">{{ viewData.partII.title }}</h4></div>
              <table class="table table-bordered custom-table">
                <thead><tr>@for (col of viewData.partII.cols; track $index) {
<th>{{ col }}</th>
}</tr></thead>
                <tbody>
                  @for (row of viewData.partII.rows; track $index) {
<tr><td></td>@for (c of viewData.partII.cols; track $index) {
<td></td>
}</tr>
}
                  @for (row of viewData.partII.rows2; track $index) {
<tr><td>{{ row.num }}</td><td colspan="8">{{ row.description }}</td><td></td></tr>
}
                </tbody>
                <tfoot>@for (foot of viewData.partII.totals; track $index) {
<tr><th></th><th colspan="7">{{ foot.description }}</th><th colspan="2"></th></tr>
}</tfoot>
              </table>
            </div>
}
            @if (viewData.partIII) {
<div class="row">
              <div class="col-md-12"><h4 style="font-weight: bold;">{{ viewData.partIII.title }}</h4></div>
              <table class="table table-bordered custom-table">
                <thead><tr>@for (col of viewData.partIII.cols; track $index) {
<th>{{ col }}</th>
}</tr></thead>
                <tbody>
                  @for (row of viewData.partIII.rows; track $index) {
<tr><td></td>@for (c of viewData.partIII.cols; track $index) {
<td></td>
}</tr>
}
                  @for (row of viewData.partIII.rows2; track $index) {
<tr><td>{{ row.num }}</td><td colspan="5">{{ row.description }}</td><td>{{ row.propertyA }}</td><td>{{ row.propertyB }}</td><td>{{ row.propertyC }}</td><td>{{ row.propertyD }}</td></tr>
}
                  @for (foot of viewData.partIII.totals; track $index) {
<tr><th></th><th colspan="5">{{ foot.description }}</th><th></th><th></th><th></th><th></th></tr>
}
                  @for (row of viewData.partIII.rows3; track $index) {
<tr><th colspan="10">{{ row.description }}</th></tr>
}
                  @for (row of viewData.partIII.rows4; track $index) {
<tr><td>{{ row.num }}</td><td colspan="7">{{ row.description }}</td><td colspan="2"></td></tr>
}
                </tbody>
              </table>
            </div>
}
            @if (viewData.partIV) {
<div class="row">
              <div class="col-md-12"><h4 style="font-weight: bold;">{{ viewData.partIV.title }}</h4></div>
              <table class="table table-bordered custom-table">
                <thead><tr><th></th>@for (col of viewData.partIV.cols; track $index) {
<th>{{ col }}</th>
}</tr></thead>
                <tbody>
                  @for (row of viewData.partIV.rows; track $index) {
<tr><td>{{ row.num }}</td><td>{{ row.description }}</td><td></td><td></td></tr>
}
                </tbody>
              </table>
            </div>
}
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
